import {
  Component,
  HostBinding,
  Input,
  OnInit,
  ViewEncapsulation,
  ChangeDetectionStrategy
} from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { SvgLoaderService } from '../../services/svg-loader.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-svg-icon',
  imports: [CommonModule],
  templateUrl: './svg-icon.component.html',
  styleUrl: './svg-icon.component.scss',
  host: {
    '[style.width]': '"24px"',
    '[style.height]': '"24px"',
    '[style.display]': '"inline-block"',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class SvgIconComponent implements OnInit {
  @Input({ required: true }) path!: string;

  svgContent!: Observable<SafeHtml>;

  constructor(private svgLoader: SvgLoaderService) {}

  ngOnInit(): void {
    this.svgContent = this.svgLoader.getInlineSvg(this.path);
  }
}
